<template>
  <div data-component="Lot/Informations" class="">
    <div class="is-flex is-flex-ended">
      <div>
        <!-- <Button>Relever les coordonnées</Button> -->
        <!-- @TODO uncomment when the feature is ready (Lot 2) -->
        <!-- <Button disabled>Call Center</Button> -->
      </div>
    </div>

    <div class="is-flex">
      <table>
        <thead>
          <tr>
            <th>Résidence</th>
            <th>Etage</th>
            <th>Porte</th>
            <th>Digicode</th>
            <th>Latitude</th>
            <th>Longitude</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ residence }}</td>
            <td>{{ floor }}</td>
            <td>{{ door }}</td>
            <td>{{ digicode }}</td>
            <td>{{ lat }}</td>
            <td>{{ lng }}</td>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>PDL Gaz</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ pdlGaz }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="is-flex">
      <table>
        <thead>
          <tr>
            <th>Code Immeuble</th>
            <th>Type de lot</th>
            <th>Lot père</th>
            <th>Nombre de pièces</th>
            <th>Surface</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ propertyCode }}</td>
            <td>{{ type }}</td>
            <td>
              <router-link 
                v-if="parentId" 
                :to="`/dossier/${parentId}/informations`" 
                target="_blank"
              >
                {{ parentBatch }}
              </router-link>
              <template v-else>-</template>
            </td>
            <td>{{ roomNumber }}</td>
            <td>{{ areaSize }}</td>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>PDL Elec</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ pdlElec }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <section 
      v-for="(panel, index) in panels" 
      :key="index" 
      class="is-panel is-flex"
    >
      <section>
        <h2>{{ panel.title }}</h2>
        <ul>
          <li>
            <i class="ico people"></i>
            <NullableParagraph>{{ panel.people }}</NullableParagraph>
          </li>
          <li>
            <i class="ico address"></i>
            <NullableParagraph>{{ panel.address }}</NullableParagraph>
          </li>
          <li class="is-phone-numbers">
            <i class="ico phone"></i>
            <div>
              <span 
                v-for="(phone, phoneIndex) in panel.phones || []" 
                :key="`phone-${index}-${phoneIndex}`"
              >
                <h4>{{ getPhoneTypeLabel(phone.type) }}</h4>
                <NullableParagraph>{{ phone.number && trim(phone.number) ? phone.number : null }}</NullableParagraph>
              </span>
            </div>
          </li>
          <li>
            <i class="ico mail"></i>
            <NullableParagraph>{{ panel.mail }}</NullableParagraph>
          </li>
        </ul>
      </section>

      <section 
        v-for="(group, panIndex) in splitEvery(4, panel.panes || [])" 
        :key="panIndex"
      >
        <div 
          v-for="(pan, i2) in group" 
          :key="`gp-pan-${i2}`" 
          class="is-entry"
        >
          <h3>{{ pan.title }}</h3>
          <NullableParagraph>{{ pan.value }}</NullableParagraph>
        </div>
      </section>
    </section>

    <!-- TODO uncomment the following when associating lots
    <section class='is-empty'>
      <article>
        <h2>Lots associés (0)</h2>
      </article>
    </section>
    -->
    <!-- @TODO uncomment when the feature is ready (Lot 2) -->
    <!-- <section class='is-empty'>
      <article>
        <h2>Diagnostics (0)</h2>
        <Button disabled>Ajouter un diagnostique</Button>
      </article>
    </section> -->
  </div>
</template>

<script>
import { trim } from 'ramda'
import dexieService from '@/services/dexieService'
import moment from 'moment'
import { h } from 'vue'

// NullableParagraph component
const NullableParagraph = {
  name: 'NullableParagraph',
  render() {
    // Récupérer le contenu depuis les slots
    const slots = this.$slots.default ? this.$slots.default() : null
    let content = null
    
    if (slots && slots.length > 0) {
      // Extraire le texte du premier slot
      const firstSlot = slots[0]
      if (firstSlot.children && typeof firstSlot.children === 'string') {
        content = firstSlot.children
      } else if (typeof firstSlot === 'string') {
        content = firstSlot
      }
    }
    
    // Vérifier si le contenu est valide
    if (content && content !== '' && content !== null && content !== undefined) {
      return h('p', {}, content)
    } else {
      return h('p', { class: 'unavailable' }, 'Non renseigné')
    }
  }
}

export default {
  name: 'LotInformations',
  
  components: {
    NullableParagraph
  },

  data() {
    return {
      roomNumber: 1,
      residence: '-',
      floor: '-',
      door: '-',
      digicode: '-',
      lat: '-',
      lng: '-',
      propertyCode: '-',
      parentBatch: '-',
      parentId: '',
      type: '-',
      areaSize: '-',
      pdlGaz: '-',
      pdlElec: '-',
      panels: [],
      loading: true,
      propertyTypes: {},
      assistanceMandators: {},
      managerMandators: {}
    }
  },

  async mounted() {
    await this.loadPropertyTypes()
    await this.loadAssistanceMandators()
    await this.loadManagerMandators()
    await this.loadLotData()
  },

  methods: {
    trim,

    // Formater une date (compatible avec le code Epic)
    formatDate(dateString) {
      if (!dateString) return ''
      return moment(dateString).format('DD/MM/YYYY')
    },

    // Formater une adresse (logique du code Epic)
    formatAddress(address) {
      if (!address) return ''
      
      const { street, street2, zipCode, city } = address
      const stripComa = (str) => (str || '').replace(/,/g, '')
      
      let fullStreet = `${stripComa(street) || ''}${street2 ? stripComa(street2) + ', ' : ', '}`
      
      if (fullStreet.trim() === ',') {
        fullStreet = ''
      }
      
      return `${fullStreet}${zipCode ? zipCode + ' ' : ''}${city || ''}`.trim()
    },

    // Récupérer une valeur depuis un dictionnaire
    itemValue(key, items) {
      if (!items || !Array.isArray(items)) return ''
      const found = items.find(item => item.key === key)
      return found ? found.value : ''
    },

    // Formater les numéros de téléphone d'un propriétaire/occupant
    formatPhoneOwner(owner) {
      if (!owner) return {}
      
      const { phoneNumber, mobilePhoneNumber, officePhoneNumber, ...rest } = owner
      
      return {
        ...rest,
        phones: [
          { type: 'home', number: phoneNumber },
          { type: 'mobile', number: mobilePhoneNumber },
          { type: 'office', number: officePhoneNumber },
        ],
      }
    },

    // Créer le panel "Dernier occupant"
    lastOccupantPanel(occupant) {
      if (!occupant) return null
      
      return {
        title: 'Dernier occupant',
        people: occupant.name,
        phones: [
          { type: 'mobile', number: occupant.mobilePhoneNumber },
          { type: 'home', number: occupant.phoneNumber },
          { type: 'office', number: occupant.officePhoneNumber },
        ],
        mail: occupant.email,
        panes: [
          { title: 'Catégorie du bail', value: occupant.leaseCategory },
          { title: 'Date d\'entrée', value: this.formatDate(occupant.arrivedAt) },
          { title: 'Date de sortie', value: this.formatDate(occupant.exitedAt) },
        ],
      }
    },

    // Créer le panel "Propriétaire"
    ownerPanel(owner) {
      if (!owner) return null
      
      return {
        title: 'Propriétaire',
        people: owner.name,
        address: this.formatAddress(owner.address),
        phones: [
          { type: 'mobile', number: owner.mobilePhoneNumber },
          { type: 'home', number: owner.phoneNumber },
          { type: 'office', number: owner.officePhoneNumber },
        ],
        mail: owner.email,
        panes: [],
      }
    },

    // Créer le panel "Gestion Propriétaire"
    managerPanel(manager) {
      if (!manager || !manager.mandator || !manager.mandator.id) return null
      
      // Récupérer les informations du mandant depuis Dexie
      const mandatorId = manager.mandator.id
      const mandatorData = this.managerMandators[mandatorId]
      
      // Si le mandant n'est pas trouvé dans Dexie, utiliser les données de la propriété comme fallback
      const mandatorName = mandatorData?.name || manager.mandator.name || '-'
      const mandatorAddress = mandatorData?.address || manager.mandator.address || null
      
      return {
        title: 'Gestion Propriétaire',
        people: mandatorName,
        address: this.formatAddress(mandatorAddress),
        phones: [
          { type: 'mobile', number: manager.mandator.mobilePhoneNumber },
          { type: 'home', number: manager.mandator.phoneNumber },
          { type: 'office', number: manager.mandator.officePhoneNumber },
        ],
        mail: manager.mandator.email,
        panes: [
          { title: 'Date de début de gestion', value: this.formatDate(manager.startedAt) },
          { title: 'Date de fin de gestion', value: this.formatDate(manager.endedAt) },
          { title: 'Date d\'état de gestion', value: this.formatDate(manager.statusUpdatedAt) },
          { title: 'État de gestion', value: manager.status },
          { title: 'Code immeuble', value: manager.propertyCode },
          { title: 'Code lot', value: manager.unitCode },
        ],
      }
    },

    // Créer le panel "Convention d'assistance"
    async assistancePanel(property, assistance, units, subUnits) {
      if (!assistance || !assistance.mandator || !assistance.mandator.id) return null
      
      // Récupérer les informations du mandant depuis Dexie
      const mandatorId = assistance.mandator.id
      const mandatorData = this.assistanceMandators[mandatorId]
      
      // Si le mandant n'est pas trouvé dans Dexie, utiliser les données de la propriété comme fallback
      const mandatorName = mandatorData?.name || assistance.mandator.name || '-'
      const mandatorAddress = mandatorData?.address || assistance.mandator.address || null
      
      return {
        title: 'Convention d\'assistance',
        people: mandatorName,
        address: this.formatAddress(mandatorAddress),
        mail: assistance.mandator.email,
        phones: [
          { type: 'mobile', number: assistance.mandator.mobilePhoneNumber },
          { type: 'home', number: assistance.mandator.phoneNumber },
          { type: 'office', number: assistance.mandator.officePhoneNumber },
        ],
        panes: [
          { title: 'Date de début de gestion', value: this.formatDate(assistance.startedAt) },
          { title: 'Date de fin de gestion', value: this.formatDate(assistance.endedAt) },
          { title: 'Date d\'état de gestion', value: this.formatDate(assistance.statusUpdatedAt) },
          { title: 'État de gestion', value: assistance.status },
          { title: 'Code immeuble', value: assistance.propertyCode },
          { title: 'Code lot', value: assistance.unitCode },
          { title: 'Unité', value: this.itemValue(property.businessUnit, units) },
          { title: 'Sous-unité', value: this.itemValue(property.businessSubUnit, subUnits) },
        ],
      }
    },

    // Construire les panels selon la logique du code Epic
    async buildPanels(property, units, subUnits) {
      const panelBuilders = [
        {
          data: property.assistance,
          formater: async (data) => await this.assistancePanel(property, data, units, subUnits)
        },
        {
          data: property.manager,
          formater: (data) => this.managerPanel(data)
        },
        {
          data: property.legalOwner,
          formater: (data) => this.ownerPanel(data)
        },
        {
          data: property.lastOccupant,
          formater: (data) => this.lastOccupantPanel(data)
        },
      ]

      // Filtrer les panels avec données valides et les formater
      const panels = []
      for (const builder of panelBuilders) {
        if (builder.data && builder.data.id && builder.data.id !== '') {
          const panel = await builder.formater(builder.data)
          if (panel) {
            panels.push(panel)
          }
        }
      }

      return panels
    },

    async loadPropertyTypes() {
      try {
        let cachedTypes = await dexieService.getDictionary('property_type')
        
        // Vérifier si les données sont dans la structure de l'ancienne app (avec items)
        if (cachedTypes && cachedTypes.items && Array.isArray(cachedTypes.items)) {
          // Convertir le tableau items en objet clé-valeur
          const typeMap = {}
          cachedTypes.items.forEach(item => {
            if (item.key && item.value) {
              typeMap[item.key] = item.value
            }
          })
          this.propertyTypes = typeMap
          return
        }
        
        // Sinon, vérifier si c'est déjà un objet clé-valeur
        if (cachedTypes && Object.keys(cachedTypes).length > 0) {
          this.propertyTypes = cachedTypes
          return
        }
        
        this.propertyTypes = {}
      } catch (error) {
        console.error('Erreur lors du chargement des types de propriété:', error)
        this.propertyTypes = {}
      }
    },

    async loadAssistanceMandators() {
      try {
        const { assistanceMandators } = await import('@/services/dexieService')
        
        // Récupérer tous les assistanceMandators depuis Dexie
        const mandators = await assistanceMandators().toArray()
        
        // Créer une map pour un accès rapide par ID avec toutes les informations
        const mandatorsMap = {}
        mandators.forEach(mandator => {
          if (mandator.id) {
            mandatorsMap[mandator.id] = {
              name: mandator.name || '',
              address: mandator.address || null
            }
          }
        })
        
        this.assistanceMandators = mandatorsMap
      } catch (error) {
        console.error('Erreur lors du chargement des assistanceMandators:', error)
        this.assistanceMandators = {}
      }
    },

    async loadManagerMandators() {
      try {
        const { managerMandators } = await import('@/services/dexieService')
        
        // Récupérer tous les managerMandators depuis Dexie
        const mandators = await managerMandators().toArray()
        
        // Créer une map pour un accès rapide par ID avec toutes les informations
        const mandatorsMap = {}
        mandators.forEach(mandator => {
          if (mandator.id) {
            mandatorsMap[mandator.id] = {
              name: mandator.name || '',
              address: mandator.address || null
            }
          }
        })
        
        this.managerMandators = mandatorsMap
      } catch (error) {
        console.error('Erreur lors du chargement des managerMandators:', error)
        this.managerMandators = {}
      }
    },

    getPropertyType(typeCode) {
      if (!typeCode) return 'Non défini'
      
      if (this.propertyTypes && this.propertyTypes[typeCode]) {
        return this.propertyTypes[typeCode]
      }
      
      return typeCode
    },

    async loadLotData() {
      try {
        this.loading = true
        
        // Récupérer l'ID du lot depuis la route
        const lotId = this.$route.params.id
        
        if (!lotId) {
          console.error('Aucun ID de lot fourni dans la route')
          return
        }

        // Récupérer les données du lot depuis IndexedDB via Dexie
        const property = await dexieService.getProperty(lotId)
        
        if (!property) {
          console.warn('Aucune propriété trouvée pour l\'ID:', lotId)
          return
        }

        // Récupérer les dictionnaires nécessaires
        const units = await dexieService.getDictionary('units') || []
        const subUnits = await dexieService.getDictionary('sub_units') || []

        // Mapper les données de la propriété aux variables du composant
        this.roomNumber = property.roomNumber || 1
        this.residence = property.residence || property.address?.building || '-'
        this.floor = property.floor || '-'
        this.door = property.door || '-'
        this.digicode = property.digicode || property.address?.digicode || '-'
        this.lat = property.lat || property.address?.latitude || '-'
        this.lng = property.lng || property.address?.longitude || '-'
        this.propertyCode = property.propertyCode || '-'
        
        // Parent lot
        this.parentBatch = property.relatedParent?.nsil || property.parentBatch || '-'
        this.parentId = property.relatedParent?.id || property.parentId || ''
        
        // Convertir le code du type en libellé
        this.type = this.getPropertyType(property.type)
        this.areaSize = property.surface || '-'
        this.pdlGaz = property.pdlGaz || '-'
        this.pdlElec = property.pdlElec || '-'

        // Construire les panels selon la logique du code Epic
        this.panels = await this.buildPanels(property, units, subUnits)

      } catch (error) {
        console.error('Erreur lors du chargement des données du lot:', error)
      } finally {
        this.loading = false
      }
    },

    getPhoneTypeLabel(type) {
      const labels = {
        mobile: 'Portable :',
        home: 'Domicile :',
        office: 'Bureau :'
      }
      return labels[type] || 'Téléphone :'
    },

    splitEvery(n, array) {
      if (!array || !Array.isArray(array)) return []
      const result = []
      for (let i = 0; i < array.length; i += n) {
        result.push(array.slice(i, i + n))
      }
      return result
    }
  },

  watch: {
    '$route.params.id': {
      handler() {
        this.loadLotData()
      },
      immediate: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './Informations.scss';
</style>
